module.exports = __webpack_public_path__ + "img/empty.e5305a62.png";